import React, { useEffect, useRef } from 'react';
import { Grid16 } from '@carbon/icons-react';
import { useDispatch, connect } from 'react-redux';
import { RootState } from 'redux/root.reducer';
import { CFCProps } from 'types';
import PropTypes from 'prop-types';
import { Button } from 'carbon-components-react';
import { isMobile } from 'react-device-detect';
import { getBaseMapsStart, setIsOpenBaseMapPanel } from 'redux/map/actions';

const BaseMapSwitcher: React.FC<Props> = ({
  isOpen,
  basemapOptions,
  error,
  buttonSize,
  buttonKind,
  buttonClassName,
  buttonDisabled,
  buttonIconDescription,
  buttonTooltipPosition,
  onOpenBasemap
}) => {
  const dispatch = useDispatch();
  const { loadedMapModules } = window;
  const basemapButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    loadedMapModules &&
      basemapOptions.length === 0 &&
      error === '' &&
      dispatch(getBaseMapsStart());
  }, [loadedMapModules, basemapOptions, error, dispatch]);

  useEffect(() => {
    if (!isOpen) {
      basemapButtonRef?.current?.blur();
    }
    onOpenBasemap && onOpenBasemap(isOpen);
  }, [isOpen, onOpenBasemap]);

  return (
    <div
      className={`base-map-switcher-container${isMobile ? ' is-mobile' : ''}`}
    >
      <Button
        renderIcon={Grid16}
        iconDescription={buttonIconDescription}
        tooltipPosition={buttonTooltipPosition}
        hasIconOnly
        kind={buttonKind}
        size={buttonSize}
        disabled={buttonDisabled}
        className={buttonClassName}
        onClick={() => dispatch(setIsOpenBaseMapPanel(!isOpen))}
        ref={basemapButtonRef}
      />
    </div>
  );
};

const propTypes = {
  buttonSize: PropTypes.string,
  buttonKind: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  buttonClassName: PropTypes.string,
  buttonIconDescription: PropTypes.string,
  buttonTooltipPosition: PropTypes.string,
  onOpenBasemap: PropTypes.func
};

type ownProps = PropTypes.InferProps<typeof propTypes>;

BaseMapSwitcher.defaultProps = {
  buttonSize: 'small',
  buttonKind: 'tertiary',
  buttonDisabled: false,
  buttonClassName: 'base-map-switcher-button',
  buttonIconDescription: 'Map style',
  buttonTooltipPosition: 'right'
};

const mapStateToProps = ({ mapCache }: RootState) => ({
  basemapOptions: mapCache.basemapOptions,
  isOpen: mapCache.IsOpenBaseMapPanel,
  error: mapCache.basemapError
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector> & ownProps;

export default React.memo(connector(BaseMapSwitcher));
